import React, { useState } from "react";
import { Typography, Divider, IconButton, Button } from "@mui/material";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { motion } from "framer-motion";
import { useStateContext } from "../../contexts/ContextProvider"; // Adjust the path

const SlideBox = ({ data, buttonContent = null }) => {
  const { aboutToolsSlide, setAboutToolsSlide } = useStateContext(); // Access the global slide state from context
  const [direction, setDirection] = useState("left");

  const hasMultipleSlides = data.length > 1;

  const handlePrev = () => {
    setDirection("left");
    const newSlide = (aboutToolsSlide - 1 + data.length) % data.length;
    console.log('Previous Slide:', newSlide); // Check slide change
    setAboutToolsSlide(newSlide); // Update the global slide state
  };

  const handleNext = () => {
    setDirection("right");
    const newSlide = (aboutToolsSlide + 1) % data.length;
    console.log('Previous Slide:', newSlide); // Check slide change
    setAboutToolsSlide(newSlide); // Update the global slide state
  };

  const variants = {
    enter: (direction) => ({
      x: direction === "left" ? -50 : 50,
      opacity: 0,
    }),
    center: { x: 0, opacity: 1 },
    exit: (direction) => ({
      x: direction === "left" ? 100 : -100,
      opacity: 0,
    }),
  };

  return (
    <div className="relative w-full h-full bg-transparent flex items-center justify-center">
      {/* Left Arrow Button */}
      {hasMultipleSlides && (
        <IconButton
          onClick={handlePrev}
          className="text-gray-400 hover:text-white absolute left-0 top-1/2 transform -translate-y-1/2"
        >
          <ArrowLeft />
        </IconButton>
      )}

      {/* Right Arrow Button */}
      {hasMultipleSlides && (
        <IconButton
          onClick={handleNext}
          className="text-gray-400 hover:text-white absolute right-0 top-1/2 transform -translate-y-1/2"
        >
          <ArrowRight />
        </IconButton>
      )}

      <motion.div
        className="w-full max-w-[92%] text-white bg-transparent"
        custom={direction}
        variants={variants}
        initial="enter"
        animate="center"
        exit="exit"
      >
        {/* Icon */}
        <Typography className="flex justify-center items-center text-3xl mb-2 mt-4">
          {data[aboutToolsSlide].icon}
        </Typography>

        {/* Title with Max Space Between Arrows */}
        <div className="flex items-center justify-between w-full relative">
          <Typography className="text-center font-bold flex-1 mx-6 text-lg desktop1680:text-xl desktop1920:text-2xl desktop2560:text-3xl">
            {data[aboutToolsSlide].headline}
          </Typography>
        </div>

        {/* Divider */}
        <Divider className="my-2 desktop1600:my-4 border-gray-600 mx-auto w-[80%] desktop2560:my-10" />

        {/* Paragraphs */}
        {data[aboutToolsSlide].paragraphs.map((paragraph, index) => (
          <Typography
            key={index}
            className={`text-center text-sm px-6 ${
              index === 0 ? "mb-4" : "hidden desktop1600:block"
            } desktop1920:text-lg`}
          >
            {paragraph}
          </Typography>
        ))}

        {/* Conditionally Render Button */}
        {buttonContent && (
          <div className="flex justify-center">
            <Button
              variant="outlined"
              className="my-2 desktop1440:my-6 desktop2560:my-10 desktop1920:py-2 desktop2560:py-4  px-8 desktop1920:px-8 desktop2560:px-10 text-sm desktop1920:text-lg desktop2560:text-xl"
              sx={{
                borderColor: "rgba(156, 163, 175, 0.5)",
                borderWidth: "2px",
                color: "rgba(156, 163, 175, 1)",
                textTransform: "none",
                transition: "all 0.3s ease",
                "&:hover": {
                  borderWidth: "2px",
                  borderColor: "transparent",
                  borderImage: "linear-gradient(to right, #8018e7, #10b981, #3b82f6) 1",
                  color: "rgba(255, 255, 255, 1)",
                },
              }}
              component="a"
              href={buttonContent.Href}
              target={buttonContent.Target}
              rel={buttonContent.Rel}
            >
              {buttonContent.Text}
            </Button>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default SlideBox;
